var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 32,
    viewBox: "0, 0, 400,400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M190.234 62.593 C 128.612 70.219,102.390 148.398,147.106 191.177 L 151.953 195.814 144.888 198.710 C 95.880 218.797,62.500 269.926,62.500 324.905 L 62.500 337.500 200.000 337.500 L 337.500 337.500 337.495 324.805 C 337.475 269.617,304.202 218.963,254.530 198.501 L 248.047 195.830 253.527 190.298 C 278.955 164.625,282.374 124.092,261.639 94.099 C 245.963 71.423,218.128 59.141,190.234 62.593 M207.227 88.629 C 241.163 92.005,260.690 134.161,241.978 163.652 C 213.866 207.958,145.327 183.895,150.921 131.683 C 153.525 107.374,179.367 84.890,201.172 87.962 C 202.031 88.083,204.756 88.384,207.227 88.629 M219.141 214.543 C 266.747 222.498,303.253 260.507,311.161 310.352 L 311.502 312.500 200.175 312.500 L 88.847 312.500 89.372 308.033 C 96.397 248.260,157.496 204.243,219.141 214.543 ",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1);
export default __webpack_public_path__ + "static/media/user1.64a24c775a608de0f7e0a7f22d32b825.svg";
export { ForwardRef as ReactComponent };